import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import BookCTA from "@/components/BookCTA";

const HomeHero = () => {
  return (
    <section className="relative overflow-hidden py-16 sm:py-24 lg:py-32">
      <div className="absolute top-12 left-[5%] w-28 h-28 bg-primary/25 brutal-border rotate-12 hidden lg:block" />
      <div className="absolute top-20 right-[8%] w-24 h-24 bg-secondary/25 brutal-border -rotate-12 hidden lg:block" />
      <div className="absolute bottom-20 left-[12%] w-16 h-16 bg-primary/15 brutal-border rotate-45 hidden lg:block" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 max-w-3xl">
        <div className="inline-flex items-center gap-2 brutal-border brutal-shadow bg-primary px-5 py-2 mb-8 rounded-full">
          <Sparkles className="w-4 h-4 text-foreground" />
          <span className="font-black text-xs tracking-widest uppercase text-foreground">
            Launching May 2026 — 80+ AI Prompts
          </span>
        </div>

        <h1 className="text-4xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.9] mb-6 text-foreground">
          The AI Founder Toolkit — Build Your Startup Solo
        </h1>

        <p className="text-lg sm:text-xl max-w-2xl mx-auto mb-10 text-muted-foreground font-medium">
          Just the right prompts — in the right order. Co-Found with AI is the step-by-step playbook for founders building with AI as their co-founder.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/chapter-1"
            className="brutal-border brutal-shadow-lg bg-primary text-primary-foreground font-bold px-8 py-3 text-lg hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all rounded-md uppercase tracking-[0.08em]"
          >
            Try the first prompt, free
          </Link>
          <BookCTA variant="card">Get Early Access →</BookCTA>
        </div>

        <p className="text-sm font-medium text-muted-foreground">
          Beta readers across 12 countries
        </p>
      </div>
    </section>
  );
};

export default HomeHero;
